export default {"src":"/_next/static/media/Sciatica.d92859a1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};